<template>
  <div class="search">
    <div>
      <div v-for="(se, index) in inputsList" :key="se.name" class="search-item" :class="'search-item-' + se.name">
        <template v-if="se.type === 'input'">
          <!-- 输入框 -->
          <label class="search-title">{{se.label}}</label>
          <Input v-model="se.input" :placeholder="'请输入' + se.label" style="width: 156px" :class="{'search-last': index + 1 === inputsList.length}"/>
        </template>
        <template v-else-if="se.type === 'date'">
          <!-- 时间 -->
          <label class="search-title">{{se.label}}</label>
          <DatePicker ref="startDate" v-model="se.start" :clearable="false" :editable="false" type="date" placeholder="开始日期" style="width: 120px"></DatePicker>
          <span class="line"></span>
          <DatePicker ref="endDate" v-model="se.end" :clearable="false" :editable="false" type="date" placeholder="结束日期" style="width: 120px" :class="{'search-last': index + 1 === inputsList.length}"></DatePicker>
        </template>
        <template v-else-if="se.type === 'select' && se.multi">
          <label class="search-title">{{se.label}}</label>
          <!-- <Select v-model="se.arr" multiple style="width:156px" @on-change="changeSel">
            <Option v-for="opt in se.optList" :value="opt.value" :key="opt.value">{{ opt.name }}</Option>
          </Select> -->
          <select-placeholder
            :id="se.name"
            :value="se.arr"
            :options="se.optList"
            :class="{'search-last': index + 1 === inputsList.length}"
            @change="selectChange"
          ></select-placeholder>
        </template>
        <template v-else-if="se.type === 'select-single'">
          <!-- 输入框 -->
          <label class="search-title">{{se.label}}</label>
          <!-- <Input v-model="se.input" :placeholder="'请输入' + se.label" style="width: 156px"/> -->
          <Select v-model="se.value" :placeholder="se.placeholder || '请输入' + se.label" class="trans-type" :class="{'search-last': index + 1 === inputsList.length}">
            <Option v-for="(item, index) in se.options"
              :key="item.value + index"
              :value="item.value"
              :label="item.label"
            ></Option>
          </Select>
        </template>
      </div>
      <div class="search-item search-item-btn">
        <button @click="search" class="ivu-btn ivu-btn-primary">查询</button>
      </div>
    </div>
    <div v-if="hasExport" class="search-item export-link link-btn link-btn-default" @click="exportTable">
      <i class="yjh-icon icon-export"></i><span>导出数据</span>
    </div>
  </div>
</template>

<script>
// 目前支持企业编码code、企业名称name、客户名称customName、收款方payee、付款方payer、注册时间regDate、日期date
// export是特殊存在，导出
// 如果后续有其他通用的加在defaultList里，如果只有一个页面就通过searchList传入数组，结构同defaultList，区分type为input和date
// emit exportTable, emit search， 传上去的参数是每条的name，如果父组件参数名不一样在父组件里处理
import { dateObjToStr2 } from '@/utils/common'
import selectPlaceholder from '@/components/reSelect/selectPlaceholder'

export default {
  name: 'pageSearch',
  components: { selectPlaceholder },
  props: {
    searchList: {
      type: Array,
      deafult: []
    },
    layout: {
      type: Array,
      default() {
        return ['code', 'name', 'date']
      }
    }
  },
  data() {
    return {
      inputsList: [], // 构造显示的筛选项
      defaultList: [
        { name: 'code', type: 'input', label: '企业编码', input: '' },
        { name: 'name', type: 'input', label: '企业名称', input: '' },
        { name: 'customName', type: 'input', label: '客户名称', input: '' },
        { name: 'payee', type: 'input', label: '收款方', input: '' },
        { name: 'payer', type: 'input', label: '付款方', input: '' },
        { name: 'regDate', type: 'date', label: '注册时间', start: '', end: '' },
        { name: 'date', type: 'date', label: '日期', start: '', end: '' },
        { name: 'type', type: 'select-single', label: '转账方式', value: '', placeholder: '全部',
          options: [{ value: '0', label: '全部' }, { value: '1', label: '收转付' }, { value: '2', label: '付转收' }]
        },
        { name: 'payType', type: 'select-single', label: '支付方式', value: '', placeholder: '全部',
          options: [{ value: '-1', label: '全部' }, { value: '1', label: '支付宝' }, { value: '3', label: '会员赠送' }]
        },
        { name: 'invoiceStatus', type: 'select-single', label: '发票状态', value: '', placeholder: '全部',
          options: [{ value: '-1', label: '全部' }, { value: '0', label: '待审核' }, { value: '1', label: '待邮寄' }]
        },
        { name: 'invoiceCode', type: 'input', label: '申请编号', input: '' },
        { name: 'invoiceTitle', type: 'input', label: '发票抬头', input: '' },
        { name: 'invoiceDate', type: 'date', label: '申请日期', start: '', end: '' }
      ]
    }
  },
  mounted() {
    this.formList()
  },
  computed: {
    hasExport() {
      return this.layout.indexOf('export') !== -1
    }
  },
  watch: {
    $route() {
      this.$refs.startDate && this.$refs.startDate[0] && (this.$refs.startDate[0].focusedDate = new Date())
      this.$refs.endDate && this.$refs.endDate[0] && (this.$refs.endDate[0].focusedDate = new Date())
      this.inputsList.map(item => {
        if (item.type === 'input') {
          item.input = ''
        } else if (item.type === 'select-single') {
          item.value = ''
        } else {
          item.start = ''
          item.end = ''
        }
      })
    },
    layout: {
      handler: function() {
        this.formList()
      },
      deep: true
    }
  },
  methods: {
    formList() {
      const list = []
      if (this.layout.length !== 0) {
        this.layout.map(lay => {
          const index = this.defaultList.findIndex(item => {
            return item.name === lay
          })
          if (index !== -1) {
            list.push(this.defaultList[index])
          }
        })
      }
      if (this.searchList && this.searchList.length) {
        this.inputsList = list.concat(this.searchList)
      } else {
        this.inputsList = list
      }
    },
    // 判断是否合法
    checkValid() {
      if (this.inputsList.length === 0) {
        return
      }
      let flag = false
      this.inputsList.map(item => {
        if (item.start !== '' && item.end !== '' && item.start > item.end) {
          this.$Message.info('开始时间必须小于结束时间')
          flag = true
        }
        return item.type === 'date'
      })
      if (!flag) {
        const query = {}
        this.inputsList.map(item => {
          if (item.type === 'date') {
            query[item.name] = [dateObjToStr2(item.start), item.end ? dateObjToStr2(item.end) + ' 23:59:59' : '']
          } else if (item.type === 'select') {
            query[item.name] = item.arr
          } else if (item.type === 'select-single') {
            query[item.name] = item.value
          } else {
            query[item.name] = item.input
          }
        })
        return query
      } else {
        return false
      }
    },
    // 搜索
    search() {
      const query = this.checkValid()
      if (typeof query === 'object') {
        this.$emit('search', query)
      }
    },
    // 导出
    exportTable() {
      this.$emit('exportTable')
    },
    selectChange(id, arr) {
      this.inputsList.map(item => {
        if (item.name === id) {
          if (arr.includes('null')) {
            item.arr = []
          } else {
            item.arr = arr
          }
        }
        return item
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.search {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .trans-type {
    width: 156px;
    /deep/ .ivu-select-dropdown {
      width: 156px !important;
    }
  }
}
.search-last {
  margin-right: 40px;
}
/deep/ .ivu-input::placeholder {
  color: #D3DAE3;
}
</style>
